<template>
  <div>
   
    <CCard class="h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center">
          <CContainer>
            <CCol sm="12" lg="12">
              <h4
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size:24px"
              >{{ qSummary.subject }}</h4>
              <h5
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size:15px"
              >{{ qSummary.grade }}</h5>
              <h5
                class="text-left mt-2 d-flex d-sm-none text-black bold"
                style="font-size:15px"
              >{{ qSummary.quizName }}</h5>

              <h5 class="text-left mt-4 d-flex d-sm-none text-black bold" style="font-size:15px">
                <br />
                Question {{ questionDetail.questionNum }}
              </h5>

              <br />

              <CCol>
                <CTextarea
                  v-model="questionDetail.question"
                  class="mt-2"
                  placeholder="Question"
                  style="border: 2px solid #009688; border-radius:10px;"
                  vertical
                  rows="5"
                />
              </CCol>

              <CCol>
                <CRow>
                  <div class="mt-2 pl-3">A:</div>
                  <CTextarea
                    v-model="questionDetail.choiceA"
                    class="mr-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>

              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">B:</p>
                  <CTextarea
                    v-model="questionDetail.choiceB"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>

              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">C:</p>
                  <CTextarea
                    v-model="questionDetail.choiceC"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">D:</p>
                  <CTextarea
                    v-model="questionDetail.choiceD"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">E:</p>
                  <CTextarea
                    v-model="questionDetail.choiceE"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">F:</p>
                  <CTextarea
                    v-model="questionDetail.choiceF"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
              <CCol>
                <CRow>
                  <p class="mt-2 pl-3">G:</p>
                  <CTextarea
                    v-model="questionDetail.choiceG"
                    class="mt-0 ml-2 col-10 p-0"
                    placeholder
                    style="border: 2px solid #009688; border-radius:10px;"
                    vertical
                    rows="1"
                  />
                </CRow>
              </CCol>
            </CCol>
          </CContainer>
          <CContainer class="id">
            <div class="lines">
              <div class="word">OR</div>
            </div>

            <!-- insert image file -->
            <CCol class="inputbox" style="overflow: hidden">
              
              <!-- insert image -->
              <input
                type="file"
                id="image"
                ref="myimage"
                @change="onFileChangeApplicationDescription1"
                accept="image/x-png, image/gif, image/jpeg"
              />

              <br />
              <br />
              
              <div style="max-width:150%" id="preview">
                <img style="max-width: 60px" v-if="changeImage" :src="changeImage" />
              </div>              


              <!-- view image -->
              <div
                class="col-12 mt-2"                
                v-if="questionDetail.questionImagePath != null"
              >
                <CRow class="justify-content-center">
                  <div>
                    <img style="max-width: 80px" :src="getPic(questionDetail)" />
                  </div>
                </CRow>
              </div>
              
            </CCol>
            <br />

            <h5>Choose the answer</h5>

            <CRow>
              <CRow class="justify-content-center">
                <CCol sm="12" lg="12" class="mt-4" style="display: flex">
                  <label>
                    <input type="radio" name="radio" checked v-model="answer" value="1" />
                    <span>A</span>
                  </label>

                  <label>
                    <input type="radio" name="radio" v-model="answer" value="2" />
                    <span>B</span>
                  </label>
                </CCol>

                <CCol sm="12" lg="12" style="display: flex">
                  <label>
                    <input type="radio" name="radio" checked v-model="answer" value="3" />
                    <span>C</span>
                  </label>

                  <label>
                    <input type="radio" name="radio" v-model="answer" value="4" />
                    <span>D</span>
                  </label>
                </CCol>
              </CRow>
            </CRow>

            <!-- <CRow class="align-item-center">
                <CCol col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                  <CButton
                    class="ba"
                    @click="ansId = 1"
                    block
                    color=""
                    shape="pill"
                    style="border: 1px solid grey; "
                    >A</CButton
                  >
                </CCol>

                <CCol col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                  <CButton
                    class="form-check"
                    @click="ansId = 2"
                    block
                    color=""
                    shape="pill"
                    style="border: 1px solid grey; "
                    >B</CButton
                  >
                </CCol>

                <CCol col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                  <CButton
                    id="main"
                    @click="ansId = 3"
                    block
                    color=""
                    shape="pill"
                    style="border: 1px solid grey; "
                    >C</CButton
                  >
                </CCol>

                <CCol col="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                  <CButton
                    class="bd"
                    @click="ansId = 4"
                    block
                    color=""
                    shape="pill"
                    style="border: 1px solid grey"
                    >D</CButton
                  >
                </CCol>
            </CRow>-->

            <div>
              <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="UpdateQuestion"
              >Submit</CButton>
            </div>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>

  <!--gg  -->
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader
  },
  data() {
    return {
      backgroundBanner,
      qSummary: {},
      SubmittedForm: false,
      Error: false,
      ansId: "",
      imageId: "",
      togglePress: "",
      questionDetail: {},
      changeImage: [],
      image: null,

      image1: [],
      changeImage: null,
      files: [],
      changeImage: null
    };
  },
  async mounted() {
    this.GetQuizSummary();
    this.GetQuestDetail();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizSummary() {
      this.$API
        .get(this.$QuizSummary + "?quizId=" + this.$route.query.quizId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
          }
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },
    //Get Quiz Detail
    async GetQuestDetail() {
      this.$API
        .get(
          this.$GetQuestionDetail + "?quesId=" + this.$route.query.questionId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.questionDetail = response.data;
            if (this.questionDetail.answerA == true) {
              this.ansId = 1;
            } else if (this.questionDetail.answerB == true) {
              this.ansId = 2;
            } else if (this.questionDetail.answerC == true) {
              this.ansId = 3;
            } else if (this.questionDetail.answerD == true) {
              this.ansId = 4;
            } else if (this.questionDetail.answerE == true) {
              this.ansId = 5;
            } else if (this.questionDetail.answerF == true) {
              this.ansId = 6;
            } else {
              this.ansId = 7;
            }
             
          }
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },

    getPic(questionDetail){
      return (
        "https://pickiddo.com/Quiz/" +
        questionDetail.questionFolderName +
        "/" +
        questionDetail.questionImageName
      );
    },

    ///insert file photo
     onFileChangeApplicationDescription1(e) {
       const file = e.target.files[0];
       this.changeImage = URL.createObjectURL(file);
       this.HandleFileInputApplicationDescription1();
     },
     
     HandleFileInputApplicationDescription1() {       
       this.photo = this.$refs.myimage.files;
       this.SubmitFileApplicationDescription1();
     },
     async SubmitFileApplicationDescription1() {
       const formData = new FormData();

       formData.append("file", this.photo[0]);
       formData.append("questionId", this.$route.query.questionId);
       formData.append("quizId", this.$route.query.quizId);

       this.$API
         .post(this.$UploadPhoto, formData, {
           headers: {
             "Content-Type": "multipart/form-data"
           }
         })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.imageId = response.data;
            console.log("Upload1", this.imageId);
            console.log("Upload2", this.photo);
            console.log("Upload3", this.$route.query.questionId);
            console.log("Upload4", this.$route.query.quizId);
          }           
         })
         .catch(error => {
           console.log("Upload failed.");
           console.log(error);
         });
     },


     

    //Update question detail
    UpdateQuestion() {
      this.SubmittedForm = true;
      if (this.questionDetail.question === "") {
        this.Error = true;
      } else {
        this.Error = false;
        const formData = new FormData();
        
        var imageId = this.imageId == null ? 0 : this.imageId;
        formData.append("userId", this.$route.query.userId);
        formData.append("Id", this.$route.query.questionId);
        formData.append("QuizTitleId", this.$route.query.quizId);
        formData.append("ansId", this.ansId);
        formData.append("Question", this.questionDetail.question);
        formData.append("ChoiceA", this.questionDetail.choiceA);
        formData.append("ChoiceB", this.questionDetail.choiceB);
        formData.append("ChoiceC", this.questionDetail.choiceC);
        formData.append("ChoiceD", this.questionDetail.choiceD);
        formData.append("ChoiceE", this.questionDetail.choiceE);
        formData.append("ChoiceF", this.questionDetail.choiceF);
        formData.append("ChoiceG", this.questionDetail.choiceG);

        console.log("try", this.photo);
      
      
        return this.$API
          .post(this.$EditQuizQuestion, formData, {
            withCredentials: true
          })
          .then(response => {
            if (response.status == 200 && response.data != null) {             
              this.GoToPageQuizDraft();
            }
          })
          .catch(error => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log("failed")
              console.log(error.response.status);
              console.log(error.response.data);
            }
          });
      }
    },
    GoToPageQuizDraft() {
      this.$router.push(
        "/QuizTeacherDraft?quizId=" +
          this.$route.query.quizId +
          "&userId=" +
          this.$route.query.userId
      );
    }
  }
};
</script>

<style>
.lines {
  width: 100%;
  height: 45px;
  position: relative;
}

.lines::after,
.lines::before {
  content: "";
  position: absolute;
  margin: auto;
  height: 2px;
  background: rgb(21, 88, 55);
  width: 45%;
  top: 45%;
}

.lines::after {
  left: 0;
}

.lines::before {
  right: 0;
}

.word {
  height: 50px;
  width: 50px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  padding-top: 8px;
  font-size: 15px;
}
.inputbox {
  border: 1px solid black;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
  text-align: center;
  height: 200px;
}
#myfile {
  padding-left: 100px;
  padding-top: 40px;
}

#main:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

#main:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

#main {
  transition: all 0.5s ease-in-out;
}

.form-check:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.form-check:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.form-check {
  transition: all 0.5s ease-in-out;
}

.bd:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.bd:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.bd {
  transition: all 0.5s ease-in-out;
}

.ba:active {
  background-color: #155799;

  color: #f1f2f2;
  box-shadow: none;
}

.ba:focus,
.btn:active:focus {
  background-color: #155799;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);

  color: #f1f2f2;
  outline: 0px auto #155799;
}

.ba {
  transition: all 0.5s ease-in-out;
}

*:after,
*:before {
  box-sizing: border-box;
}

form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 200px;
  padding-right: 10px;
  padding-left: 30px;
  padding-top: 10px;
  /* Accessible outline */
  /* Remove comment to use */
  /*
      &:focus-within {
          outline: .125em solid $primary-color;
      }
    */
}

label input {
  position: absolute;
  left: -9999px;
}

label input:checked + span {
  background-color: #d6d6e5;
  width: 200px;
}
form {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  font-size: calc(1em + 1.25vw);
  color: #000021;
  width: 200px;
  padding-right: 10px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;

  /* Accessible outline */
  /* Remove comment to use */
  /*
  	&:focus-within {
  			outline: .125em solid $primary-color;
  	}
  */
}
label input {
  position: absolute;
  left: -9999px;
}
label input:checked + span {
  background-color: #d6d6e5;
  width: 200px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 1, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.19);
}
label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}
label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 2px rgb(90, 8, 138);
  width: 200px;
}
label span:hover {
  background-color: #d6d6e5;

  width: 200px;
}
label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00005c;
}

label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  border: solid 1px blue;
  width: 200px;
}

label span:hover {
  background-color: #d6d6e5;
  width: 200px;
}

label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 2.3em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #00005c;
}

#fb-root{
  display:none;
}
@media only screen and (min-width: 700px) {
  label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    font-size: larger;
    color: #000021;
    width: 235px;
    padding-right: 10px;
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
}
}
</style>
